module.exports = __webpack_public_path__ + "static/loading-state-1cb648dfcd89c51a0b22622b831d7545.png";